const appleLogin = {
  namespaced: true,
  state: {
    loading: false,
    account: null,
  },
  getters: {
    account: (state) => state.account,
    loading: (state) => state.loading,
  },
  mutations: {
    setAccount(state, account) {
      state.account = account
    },
    setLoading(state, loading) {
      state.loading = loading
    },
  },
  actions: {
    setLoading({ commit }, loading) {
      commit('setLoading', loading)
    },
    async setAccount({ commit, dispatch }, res) {
      if (res.data) {
        const { code, data } = res
        if (code == 0) {
          if (data.user) {
            dispatch('updateUserInfo', data.user, { root: true })
          } else {
            // 没有绑定账号
            dispatch('wxLogin/updateBindAccountDialog', true, { root: true })
            commit('setAccount', data)
          }
        }
      }
    },
  },
}

export default appleLogin
